import axios from "axios";
import { servicePath } from "../../utility/data";

export const signIn = async (email, password) => {
  const formData = new URLSearchParams();
  formData.append('username', email);
  formData.append('password', password);

  try {
    const response = await axios.post(`${servicePath}/auth/login`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
      },
    });
    
    return response;
  } catch (error) {
    console.error('Error during signIn:', error);
    throw new Error(error.response ? error.response.data.message : 'Login failed');
  }
};


export const userRole = (accessToken) => {
  const headers = {
      'Authorization': `Bearer ${accessToken}`
  }

  return axios
      .get(`${servicePath}/users/me`, { headers })
      .then((res) => {
          return res.data;
      })
      .catch((error) => { 
          return error.response;
      });
}


export const updatePassword = async (current_password, new_password, accessToken) => {
  const payload = {
    current_password,
    new_password
  };

  try {
      const response = await axios.post(`${servicePath}/users/update-password`, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    return response;
  } catch (error) {
    console.error('Error during signIn:', error);
    throw new Error(error.response ? error.response.data.message : 'Login failed');
  }
};

export const refreshToken = async (refreshToken) => {
  const payload = {
    refreshToken
  };

  try {
    const response = await axios.post(`${servicePath}/auth/refresh`, payload, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    return response;
  } catch (error) {
    console.error('Error during user registration:', error);
    throw new Error(error.response ? error.response.data.message : 'User registration failed');
  }
};